<template>
  <div>
    <el-dialog :close-on-click-modal="false"
        title="订单详情"
        :visible.sync="addProDialogVisible"
        :before-close="addProHandleClose"
        width="48rem"
        center
      >
        <div class="content" id="nbprint">
            <div class="name">{{row.rname}}</div>
            <div class="border"></div>
            <div class="border"></div>
            <div class="info">
                <div>
                  <span>桌号：</span>
                  <span>{{row.table}}</span>
                </div>
                <div>
                  <span>点单号：</span>
                  <span>{{row.ordernumber}}</span>
                </div>
                <div>
                  <span>下单时间：</span>
                  <span>{{row.datetime}}</span>
                </div>
            </div>
            <div class="border border_three"></div>
            <div class="dishName">
               <span>菜品名称</span>
               <div>
                  <span>单价</span>
                  <span>数量</span>
                  <span>金额</span>
               </div>
            </div>
            <div class="border border_three" ></div>
            <div class="dishName cai_one">
               <span class="cai_name">{{row.foodname}}</span>
               <div>
                  <span>{{row.money}}</span>
                  <span>{{row.num}}</span>
                  <span>{{row.money * row.num}}</span>
               </div>
            </div>
            <div class="border border_three" ></div>
            <div class="he">
                <div>
                  <span>合计：</span>
                  <span>{{row.money * row.num}}</span>
                </div>
                <div>
                  <span>备注：</span>
                  <span></span>
                </div>
            </div>
        </div>
        <div class="order_btns">
                <el-button v-print="printOption">打印</el-button>
                <!-- <div>机器补打</div> -->
            </div>
      </el-dialog>
  </div>
</template>
<script>
import print from 'vue-print-nb'
export default {
  directives: {
      print   
  },
  data(){
    return{
      addProDialogVisible:false,
      row:'',
      printOption: {
					id: 'nbprint', // 打印元素的id 不需要携带#号
					preview: true, // 开启打印预览
          standard:'HTML',
          targetStyles: ["*"],
					previewBeforeOpenCallback: () => {
						console.log("触发打印预览打开前回调");
					},
					previewOpenCallback: () => {
						console.log("触发打开打印预览回调");
					},
					beforeOpenCallback: () => {
						console.log("触发打印工具打开前回调");
					},
					openCallback: () => {
						console.log("触发打开打印工具回调");
					},
					closeCallback: () => {
						console.log("触发关闭打印工具回调");
					},
					clickMounted: () => {
						console.log("触发点击打印回调");
					}
			}
    }
  },
  methods:{
    pxFn(row){
      this.row = row
      this.addProDialogVisible = true
    },
    addProHandleClose(){
      this.addProDialogVisible = false
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  padding: 2rem 0 !important;
  border-top: 1px solid #e5e5ea;
}
.content{
  padding: 0 2rem 0 2rem;
  box-sizing: border-box;
  width: auto;
  height: 100%;
  .name{
    margin-top: 2rem;
    color: #000;
    font-size: 1.8rem;
    width: 100%;
    margin-left: 8rem;
  }
  .border{
    margin: 0 auto;
    width: 100%;
    height: 2px;
    flex-shrink: 0;
    background: #C4C4C4;
    margin-bottom:0.3rem;
    &:nth-child(2){
      margin-top: 1.6rem;
    }
  }
  .border_three{
    background: #000;
    margin-top: 1.8rem ;
    margin-bottom: 1.8rem;
    height: 1px;
  }
  .info{
    margin:0 0 0 1.5rem;
    >div{
      display: flex;
      align-items: center;
      margin-top: 1.5rem;
      span{
        font-size: 1.4rem;
        &:nth-child(1){
          color: #666;
        }
        &:nth-child(2){
          color: #000;
        }
      }
    }
  }
  .dishName{
    margin: 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
      color: #666;
      font-size: 1.2rem;
    }
    >div{
      display: flex;
      align-items: center;
      width: 18rem;
    justify-content: space-between;
      span{
        margin-left: 4.2rem;
      }
    }
  }
}
.cai_one{
  .cai_name{
    width: 10.4rem;
  }
  span{
    color: #000 !important;
  }
}
.he{
  margin-left: 1.5rem;
  >div{
    margin-bottom: 1rem;
    span{
      color: #666;
      font-size: 1.4rem;
      &:nth-child(2){
        color: #000;
      }
    }
  }
}
.order_btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  >div{
    cursor: pointer;
    width: 11rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    border: 1px solid #246DEB;
    border-radius: 4px;
    color: #246DEB;
    &:nth-child(2){
      margin-left: 2rem;
    }
  }
}
</style>